export default __webpack_public_path__ + "static/16-a99472eb78d800476d68128c189fd90f.jpg";